<app-shive-grid #gridWrapperComponent [grid]="grid">
  <kendo-grid
    kendoGridSelectBy="id"
    scrollable="none"
    [data]="projectTaskGridService.gridData()"
    [pageSize]="20"
    [selectable]="{ enabled: true, checkboxOnly: true }"
    [columnMenu]="{ filter: true }"
    (add)="openTaskDialog(UserOperation.Create)"
    #grid
  >
    <ng-template kendoGridToolbarTemplate>
      <div class="k-d-flex k-justify-content-end k-w-full">
        <button
          kendoGridAddCommand
          themeColor="secondary"
          [disabled]="gridWrapperComponent.userOperation !== UserOperation.None"
        >
          <fa-icon class="icon turquoise k-mr-3 k-mt-0.5" size="lg" [icon]="faListCheck"></fa-icon>
          <span>Aufgabe hinzufügen</span>
        </button>
      </div>
    </ng-template>

    <kendo-grid-checkbox-column
      [width]="40"
      [headerClass]="{ 'k-text-center': true }"
      class="list-selection-check"
      [resizable]="false"
      [columnMenu]="false"
      [showSelectAll]="true"
    >
    </kendo-grid-checkbox-column>

    <kendo-grid-column field="task.name" title="Bezeichnung" [class]="'!k-white-space-nowrap'">
      <ng-template kendoGridCellTemplate let-row>
        <div class="task-name">{{ row.task.name }}</div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="task.assignee" title="Zugewiesen" [class]="'cell-with-avatar'">
      <ng-template kendoGridCellTemplate let-row>
        <div class="k-d-inline-flex k-align-items-center">
          <app-shive-avatar [user]="row.task.assignee"></app-shive-avatar>
          <div class="member-name k-ml-3">{{ row.member | memberName }}</div>
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="task.status.name" title="Status">
      <ng-template kendoGridCellTemplate let-row>
        <div class="task-status">{{ row.task.status.name }}</div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="task.isBillable" title="Verrechenbar">
      <ng-template kendoGridCellTemplate let-row>
        <div>
          {{ row.task.isBillable ? "Verrechenbar" : "Nicht verrechenbar" }}
        </div>
      </ng-template>
    </kendo-grid-column>

    @if (showHourlyExpenditureRateFormField()) {
      <kendo-grid-column field="expenditureRateHistory" [title]="'Stundensatz'">
        <ng-template kendoGridCellTemplate let-row>
          {{
            +row.expenditureRateHistory[row.expenditureRateHistory.length - 1].rate | shiveCurrency
          }}
        </ng-template>
      </kendo-grid-column>
    }

    @if (showBudgetMonetaryPerTaskFormField()) {
      <kendo-grid-column field="budgetMonetary" [title]="'Budget'">
        <ng-template kendoGridCellTemplate let-row>
          {{ row.budgetMonetary | shiveCurrency }}
        </ng-template>
      </kendo-grid-column>
    }

    @if (showBudgetHoursPerTaskFormField()) {
      <kendo-grid-column field="budgetHours" [title]="'Budget'">
        <ng-template kendoGridCellTemplate let-row>
          {{ row.budgetSeconds | timeFormat: TimeFormatType.SecondsToHoursAndMinutes }}
        </ng-template>
      </kendo-grid-column>
    }

    <kendo-grid-column [columnMenu]="false" [width]="40">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-context-menu-anchor
          [dataItem]="dataItem"
          [gridWrapperComponent]="gridWrapperComponent"
        />
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</app-shive-grid>
